import {
  createSlice,
  createAsyncThunk,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit'
import md5 from 'blueimp-md5'
import store, { ActionParams, methods } from '.'
// import { WebStorage } from './ws'
import {
  WebStorage,
  NRequest,
  SAaSS,
  NEventListener,
  deepCopy,
  Debounce,
} from '@nyanyajs/utils'
import { storage } from './storage'
import { getI18n } from 'react-i18next'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
import 'moment/dist/locale/zh-tw'

import { api } from '../modules/electron/api'
import { stringify } from 'querystring'
import { resolve } from 'path'
import { nanoid } from 'nanoid'
import { sakisso, nsocketio, version, origin } from '../config'
import { i18n } from 'i18next'

export const R = new NRequest()

export const eventListener = new NEventListener()

export let sakiuiI18n: i18n

export const setSakiuiI18n = (i18n: i18n) => {
  sakiuiI18n = i18n
}

export const saass = new SAaSS({})

export const modeName = 'config'

export const configMethods = {
  Init: createAsyncThunk(modeName + '/Init', async (_, thunkAPI) => {
    // 获取配置
    store.dispatch(methods.config.getDeviceType())
    store.dispatch(methods.config.initLanguage())
    store.dispatch(methods.config.initAutoCloseWindowAfterCopy())
    store.dispatch(methods.config.initSync())
    store.dispatch(methods.config.initBackup())

    thunkAPI.dispatch(
      configSlice.actions.setTodoListDisplayItems(
        (await storage.systemConfig.get('todolistPageDisplayItems')) ||
          initialConfigState.pageConfig.todolistPage.displayItems
      )
    )
    thunkAPI.dispatch(
      configSlice.actions.setAsideContentModalWidth(
        (await storage.systemConfig.get('asideContentModalWidth')) ||
          initialConfigState.pageConfig.asideContentModal.width
      )
    )
    thunkAPI.dispatch(
      configSlice.actions.setHideIndexPageSideList(
        (await storage.systemConfig.get('hideSideList')) || false
      )
    )
    thunkAPI.dispatch(
      configSlice.actions.setAutomaticallyStart(
        (await storage.systemConfig.get('automaticallyStart')) || false
      )
    )
  }),
  getDeviceType: createAsyncThunk(
    modeName + '/getDeviceType',
    (_, thunkAPI) => {
      console.log('getDeviceType', document.body.offsetWidth)

      if (document.body.offsetWidth <= 768) {
        thunkAPI.dispatch(configSlice.actions.setDeviceType('Mobile'))
        return
      }
      if (
        document.body.offsetWidth <= 1024 &&
        document.body.offsetWidth > 768
      ) {
        thunkAPI.dispatch(configSlice.actions.setDeviceType('Pad'))
        return
      }
      thunkAPI.dispatch(configSlice.actions.setDeviceType('PC'))
    }
  ),
  initLanguage: createAsyncThunk(
    modeName + '/initLanguage',
    async (_, thunkAPI) => {
      store.dispatch(
        configSlice.actions.setLanguage({
          language: (await storage.systemConfig.get('language')) || 'system',
        })
      )
    }
  ),
  initAutoCloseWindowAfterCopy: createAsyncThunk(
    modeName + '/initLanguage',
    async (_, thunkAPI) => {
      store.dispatch(
        configSlice.actions.setAutoCloseWindowAfterCopy(
          JSON.parse(
            await storage.systemConfig.get('autoCloseWindowAfterCopy')
          ) || false
        )
      )
    }
  ),
  initSync: createAsyncThunk(modeName + '/initSync', async (_, thunkAPI) => {
    store.dispatch(
      configSlice.actions.setSync(
        JSON.parse(await storage.systemConfig.get('sync')) || false
      )
    )
  }),
  initBackup: createAsyncThunk(
    modeName + '/initBackup',
    async (_, thunkAPI) => {
      thunkAPI.dispatch(
        configSlice.actions.setBackup({
          type: 'storagePath',
          v: (await storage.systemConfig.get('backupStoragePath')) || '',
        })
      )
      thunkAPI.dispatch(
        configSlice.actions.setBackup({
          type: 'backupAutomatically',
          v:
            JSON.parse(await storage.systemConfig.get('backupAutomatically')) ||
            false,
        })
      )
      thunkAPI.dispatch(
        configSlice.actions.setBackup({
          type: 'keepBackups',
          v: (await storage.systemConfig.get('keepBackups')) || '3784320000',
        })
      )
      thunkAPI.dispatch(
        configSlice.actions.setBackup({
          type: 'automaticBackupFrequency',
          v:
            (await storage.systemConfig.get('automaticBackupFrequency')) ||
            '604800',
        })
      )
    }
  ),
  getLastBackupTime: createAsyncThunk(
    modeName + '/initBackup',
    async (_, thunkAPI) => {
      thunkAPI.dispatch(
        configSlice.actions.setBackup({
          type: 'lastBackupTime',
          v: (await storage.systemConfig.get('lastBackupTime')) || 0,
        })
      )
    }
  ),
}

export let platform: 'Electron' | 'Web' =
  window &&
  window.process &&
  window.process.versions &&
  window.process.versions['electron']
    ? 'Electron'
    : 'Web'

export let eventTarget = new EventTarget()

type DeviceType = 'Mobile' | 'Pad' | 'PC'
export let deviceType: DeviceType | undefined

export let initialConfigState = {
  logo256: (platform === 'Electron' ? './' : '/') + 'icons/256x256.png',
  layout: {
    backIcon: false,
    showCenter: false,
    centerTitle: {
      title: '',
      subtitle: '',
    },
  },
  saassConfig: {
    parameters: {
      imageResize: {
        normal: '?x-saass-process=image/resize,900,70',
        avatar: '?x-saass-process=image/resize,160,70',
        full: '?x-saass-process=image/resize,1920,70',
      },
    },
  },
  pageConfig: {
    disableChangeValue: false,
    settingPage: {
      settingType: '',
    },
    indexPage: {
      mobile: {
        showNotesListPage: true,
        showCategoryListPage: true,
        showPageListPage: false,
        showPageContentPage: false,
      },
      showSelectTypeOfAddPage: false,
      hideSideList: false,
    },
    asideContentModal: {
      visible: false,
      data: {
        noteId: '',
        categoryId: '',
        pageId: '',
        todoId: '' as string | undefined,
        type: 'Todo' as
          | 'Todo'
          | 'Catalog'
          | 'MoveTaskTo'
          | 'HistoricalVersion'
          | 'SetLabels',
      },
      width: 400,
    },
    findInAppModal: {
      visible: false,
    },
    shareNoteModal: {
      visible: false,
      noteId: '',
    },
    notePermissionsModal: {
      visible: false,
      noteId: '',
    },
    cloudNoteModal: {
      visible: false,
    },
    todolistPage: {
      displayItems: {
        CompleteCheckbox: true,
        TodoId: true,
        Importance: true,
        SubtaskCount: true,
        Labels: true,
        // 折叠完成的一级任务
        CollapseCompletedSubtasks: true,
        // 基于每个任务的折叠按钮，是否是仅折叠完成的任务
        CollapseButtonOnlyCompletedSubtasks: true,
        TaskProgressBar: true,
        ImportanceBorderColor: true,
      },
    },
  },
  version: version,
  isDev: process.env.NODE_ENV === 'development',
  networkStatus: window.navigator.onLine,
  origin: origin,
  language: '',
  lang: '',
  languages: ['zh-CN', 'zh-TW', 'en-US'],
  deviceType,
  sync: false,
  backup: {
    storagePath: '',
    backupAutomatically: false,
    automaticBackupFrequency: '-1',
    keepBackups: '-1',
    maximumStorageSpace: 512 * 1024 * 1024,
    lastBackupTime: 0,
  },
  platform,
  status: {
    noteInitStatus: false,
    sakiUIInitStatus: false,
    syncStatus: false,
    loginModalStatus: false,
    electronRouterInitStatus: false,
  },
  sakisso,
  socketIoConfig: {
    // uri: 'http://192.168.0.103:15301',
    uri: nsocketio.url,
    opt: {
      reconnectionDelay: 2000,
      reconnectionDelayMax: 5000,
      secure: false,
      autoConnect: true,
      rejectUnauthorized: false,
      transports: ['websocket'],
    },
  },
  general: {
    automaticallyStart: false,
    autoCloseWindowAfterCopy: false,
  },

  // contextMenuEl: undefined as any,
  // contextMenuConfig: {
  //   x: 0,
  //   y: 0,
  //   label: '',
  //   visible: false,
  // } as {
  //   x?: number;
  //   y?: number;
  //   label?: string;
  //   visible: boolean;
  // }
}

// const contextMenuElRenderD = new Debounce()

// export let contextMenuEl = undefined as any

// eventListener.on("contextMenuElRender", () => {
//   contextMenuElRenderD.increase(() => {
//     const { config } = store.getState()
//     console.log("contextMenuEl", config.contextMenuConfig, contextMenuEl)
//     if (config.contextMenuConfig.visible && contextMenuEl) {
//       contextMenuEl?.show({
//         x: config.contextMenuConfig.x,
//         y: config.contextMenuConfig.y,
//         label: config.contextMenuConfig.label,
//       })
//       return
//     }
//     // if (config.contextMenuEl) {
//     store.dispatch(configSlice.actions.setContextMenuEl(undefined))
//     // }
//   }, 10)
// })

export const configSlice = createSlice({
  name: modeName,
  initialState: initialConfigState,
  reducers: {
    setFindInAppModal: (
      state,
      params: ActionParams<typeof state.pageConfig.findInAppModal>
    ) => {
      state.pageConfig.findInAppModal.visible = params.payload.visible
    },
    setAutomaticallyStart: (state, params: ActionParams<boolean>) => {
      state.general.automaticallyStart = params.payload

      setTimeout(async () => {
        await storage.systemConfig.set('automaticallyStart', params.payload)

        api.updateSetting({
          type: 'automaticallyStart',
        })
      })
      // console.log(
      // 	"await storage.global.get('automaticallyStart')",
      // 	await storage.global.get('automaticallyStart')
      // )
    },
    setHideIndexPageSideList: (
      state,
      params: ActionParams<typeof state.pageConfig.indexPage.hideSideList>
    ) => {
      state.pageConfig.indexPage.hideSideList = params.payload

      // console.log("setTodoListDisplayItems", params.payload)
      storage.systemConfig.setSync('hideSideList', params.payload)
    },
    setTodoListDisplayItems: (
      state,
      params: ActionParams<typeof state.pageConfig.todolistPage.displayItems>
    ) => {
      state.pageConfig.todolistPage.displayItems = params.payload

      storage.systemConfig.setSync('todolistPageDisplayItems', params.payload)
    },
    // setContextMenuEl: (state, params: ActionParams<typeof contextMenuEl>) => {
    //   contextMenuEl = params.payload

    //   contextMenuEl && eventListener.dispatch("contextMenuElRender", undefined)
    // },
    // setContextMenuConfig: (state, params: ActionParams<typeof state.contextMenuConfig>) => {
    //   if (!params.payload.visible) {
    //     state.contextMenuConfig = {
    //       x: 0,
    //       y: 0,
    //       label: '',
    //       visible: false,
    //     }
    //     contextMenuEl = undefined
    //     return
    //   }
    //   state.contextMenuConfig = params.payload

    //   eventListener.dispatch("contextMenuElRender", undefined)
    // },
    setShowSelectTypeOfAddPage: (state, params: ActionParams<boolean>) => {
      state.pageConfig.indexPage.showSelectTypeOfAddPage = params.payload
    },
    setShareNoteModal: (
      state,
      params: ActionParams<typeof state.pageConfig.shareNoteModal>
    ) => {
      state.pageConfig.shareNoteModal = params.payload
    },
    setNotePermissionsModal: (
      state,
      params: ActionParams<typeof state.pageConfig.notePermissionsModal>
    ) => {
      state.pageConfig.notePermissionsModal = params.payload
    },
    setCloudNoteModal: (
      state,
      params: ActionParams<typeof state.pageConfig.cloudNoteModal>
    ) => {
      state.pageConfig.cloudNoteModal = params.payload
    },
    setShowAsideContentModal: (
      state,
      params: ActionParams<{
        visible: boolean
        data?: typeof state.pageConfig.asideContentModal.data
      }>
    ) => {
      state.pageConfig.asideContentModal.visible = params.payload.visible
      if (params.payload.data) {
        state.pageConfig.asideContentModal.data = params.payload.data
      } else {
        state.pageConfig.asideContentModal.data = {
          noteId: '',
          categoryId: '',
          pageId: '',
          todoId: '',
          type: 'Todo',
        }
      }
    },
    setAsideContentModalWidth: (state, params: ActionParams<number>) => {
      state.pageConfig.asideContentModal.width = params.payload
      storage.systemConfig.setSync('asideContentModalWidth', params.payload)
    },
    setLanguage: (
      state,
      params: ActionParams<{
        language: string
      }>
    ) => {
      state.language = params.payload.language
      // console.log('state.language', state.language)
      if (state.language === 'system') {
        if (state.languages.indexOf(navigator.language) >= 0) {
          getI18n().changeLanguage(navigator.language)
        } else {
          switch (navigator.language.substring(0, 2)) {
            case 'zh':
              getI18n().changeLanguage('zh-CN')
              break
            case 'en':
              getI18n().changeLanguage('en-US')
              break

            default:
              getI18n().changeLanguage('en-US')
              break
          }
        }
      } else {
        getI18n().changeLanguage(state.language)
      }
      state.lang = getI18n().language

      moment.locale(getI18n().language)
      storage.systemConfig.setSync('language', state.language)
    },
    setSync: (state, params: ActionParams<boolean>) => {
      state.sync = params.payload
      storage.systemConfig.setSync('sync', JSON.stringify(params.payload))
    },
    setSettingType: (state, params: ActionParams<string>) => {
      state.pageConfig.settingPage.settingType = params.payload
    },
    setDisableChangeValue: (state, params: ActionParams<boolean>) => {
      state.pageConfig.disableChangeValue = params.payload
      params.payload &&
        setTimeout(() => {
          store.dispatch(configSlice.actions.setDisableChangeValue(false))
        }, 300)
    },

    setHeaderCenter: (state, params: ActionParams<boolean>) => {
      state.layout.showCenter = params.payload
      console.log('setHeaderCenter', state.layout.showCenter)
    },
    setHeaderCenterTitle: (
      state,
      params: ActionParams<{
        title: string
        subtitle: string
      }>
    ) => {
      state.layout.centerTitle = params.payload
    },
    setDeviceType: (state, params: ActionParams<DeviceType>) => {
      state.deviceType = params.payload
    },
    setLayoutBackIcon: (state, params: ActionParams<boolean>) => {
      state.layout.backIcon = params.payload
    },

    setStatus: (
      state,
      params: ActionParams<{
        type:
          | 'noteInitStatus'
          | 'sakiUIInitStatus'
          | 'syncStatus'
          | 'loginModalStatus'
        v: boolean
      }>
    ) => {
      state.status[params.payload.type] = params.payload.v
    },
    setBackup: (
      state: any,
      params: ActionParams<{
        type: keyof typeof initialConfigState.backup
        v: any
      }>
    ) => {
      state.backup[params.payload.type] = params.payload.v
      switch (params.payload.type) {
        case 'storagePath':
          storage.systemConfig.setSync('backupStoragePath', params.payload.v)
          break
        case 'backupAutomatically':
          storage.systemConfig.setSync(
            'backupAutomatically',
            JSON.stringify(params.payload.v)
          )
          break

        case 'keepBackups':
          storage.systemConfig.setSync('keepBackups', params.payload.v)
          break

        case 'automaticBackupFrequency':
          storage.systemConfig.setSync(
            'automaticBackupFrequency',
            params.payload.v
          )
          break

        default:
          break
      }
    },
    setAutoCloseWindowAfterCopy: (state, params: ActionParams<boolean>) => {
      state.general.autoCloseWindowAfterCopy = params.payload
      storage.systemConfig.setSync(
        'autoCloseWindowAfterCopy',
        JSON.stringify(params.payload)
      )
    },
    setNetworkStatus: (state, params: ActionParams<boolean>) => {
      state.networkStatus = params.payload
    },
    setElectronRouterInitStatus: (state, params: ActionParams<boolean>) => {
      state.status.electronRouterInitStatus = params.payload
    },
  },
})
